import type { EuRunningTaxEstimateDto } from '@b-stock/listing-api-client'

import euTaxRunningEstimateQuery from '@/queries/euTaxRunningEstimateQuery'

// Fetches `GET /v1/eu-tax/listings/:id/running-estimate`. Public
// endpoint, so no address is required — the DTO's own
// `estimateUnavailable` discriminant carries the fail-closed signal
// (FR-020) when the server can't produce a figure.
//
// Suppression contract:
//   - `isTaxable` false → don't call. Prevents a per-listing round-trip
//     for every non-EUR listing (mirrors `useMaxTaxExposure`'s CAD gate).
//   - react-query in-flight / errored → return `undefined`. Rendering
//     nothing is safer than rendering a stale figure while data flips.
//   - `estimateUnavailable: true` is a real answer — pass it through
//     so the display renders the unavailable state, not `€0.00`.
const useEuRunningVatEstimate = ({
  isTaxable = true,
  listingId,
  buyerAddressId,
  buyerFeeCents,
  shippingCents,
}: {
  isTaxable?: boolean
  listingId: string
  buyerAddressId?: string
  buyerFeeCents?: number
  shippingCents?: number
}): EuRunningTaxEstimateDto | undefined => {
  const { data, isError } = euTaxRunningEstimateQuery.useWithOpts(
    [listingId, buyerAddressId, buyerFeeCents, shippingCents],
    { enabled: isTaxable }
  )

  if (!isTaxable || isError || !data) {
    return undefined
  }

  return data
}

export default useEuRunningVatEstimate
